export const extractClubInviteCode = (
  url: string | null | undefined,
): string | null => {
  if (!url) {
    return null;
  }

  const match = url.match(/(?:^|\/)clubs\/invite\/([^/?#]+)/i);
  if (!match?.[1]) {
    return null;
  }

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

export const shouldDeferClubInviteNavigation = (
  url: string | null | undefined,
  isUserLoggedIn: boolean,
): boolean => Boolean(extractClubInviteCode(url)) && !isUserLoggedIn;
